import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  readonly APIUrl = "https://api.stnhd.com/api/"
  //readonly APIUrl = "https://localhost:44301/api/"

  constructor(private http: HttpClient) { }
  loginUser(model): Observable<any> {
    return this.http.post<any[]>(this.APIUrl + "Login/LoginUser", model);
  }
}
